// SSV2300_CONFI_OPEDA_WS
export const SET_SSV2300_CONFI_OPEDA_WS = "setSsv2300ConfiOpedaWs";
export const SET_PAGINATED_SSV2300_CONFI_OPEDA_WSS = "setPaginatedSsv2300ConfiOpedaWs";
export const RESET_STATE_SSV2300_CONFI_OPEDA_WS_FILTERS = "resetStateSsv2300ConfiOpedaWsFilters";
export const RESET_STATE_SSV2300_CONFI_OPEDA_WS = "resetStateSsv2300ConfiOpedaWs";
export const RESET_STATE_SSV2300_CONFI_OPEDA_WS_LIST = "resetStateSsv2300ConfiOpedaWsList";

// SSV2307_USURO_CADTR_CRTOR
export const SET_SSV2307_USURO_CADTR_CRTOR = "setSsv2307UsuroCadtrCrtor";
export const SET_PAGINATED_SSV2307_USURO_CADTR_CRTORS = "setPaginatedSsv2307UsuroCadtrCrtor";
export const RESET_STATE_SSV2307_USURO_CADTR_CRTOR_FILTERS = "resetStateSsv2307UsuroCadtrCrtorFilters";
export const RESET_STATE_SSV2307_USURO_CADTR_CRTOR = "resetStateSsv2307UsuroCadtrCrtor";
export const RESET_STATE_SSV2307_USURO_CADTR_CRTOR_LIST = "resetStateSsv2307UsuroCadtrCrtorList";

// SSV2308_EXCEC_RADAR_COTAC
export const SET_SSV2308_EXCEC_RADAR_COTAC = "setSsv2308ExcecRadarCotac";
export const SET_PAGINATED_SSV2308_EXCEC_RADAR_COTACS = "setPaginatedSsv2308ExcecRadarCotac";
export const RESET_STATE_SSV2308_EXCEC_RADAR_COTAC_FILTERS = "resetStateSsv2308ExcecRadarCotacFilters";
export const RESET_STATE_SSV2308_EXCEC_RADAR_COTAC = "resetStateSsv2308ExcecRadarCotac";
export const RESET_STATE_SSV2308_EXCEC_RADAR_COTAC_LIST = "resetStateSsv2308ExcecRadarCotacList";

// SSV2314_CADTR_FLAG_WS
export const SET_SSV2314_CADTR_FLAG_WS = "setSsv2314CadtrFlagWs";
export const SET_PAGINATED_SSV2314_CADTR_FLAG_WSS = "setPaginatedSsv2314CadtrFlagWs";
export const RESET_STATE_SSV2314_CADTR_FLAG_WS_FILTERS = "resetStateSsv2314CadtrFlagWsFilters";
export const RESET_STATE_SSV2314_CADTR_FLAG_WS = "resetStateSsv2314CadtrFlagWs";
export const RESET_STATE_SSV2314_CADTR_FLAG_WS_LIST = "resetStateSsv2314CadtrFlagWsList";

// SSV2340_CONFI_CRTOR_WS
export const SET_SSV2340_CONFI_CRTOR_WS = "setSsv2340ConfiCrtorWs";
export const SET_PAGINATED_SSV2340_CONFI_CRTOR_WSS = "setPaginatedSsv2340ConfiCrtorWs";
export const RESET_STATE_SSV2340_CONFI_CRTOR_WS_FILTERS = "resetStateSsv2340ConfiCrtorWsFilters";
export const RESET_STATE_SSV2340_CONFI_CRTOR_WS = "resetStateSsv2340ConfiCrtorWs";
export const RESET_STATE_SSV2340_CONFI_CRTOR_WS_LIST = "resetStateSsv2340ConfiCrtorWsList";

// SSV2341_CONFI_CRTOR_FLAG_WS
export const SET_SSV2341_CONFI_CRTOR_FLAG_WS = "setSsv2341ConfiCrtorFlagWs";
export const SET_PAGINATED_SSV2341_CONFI_CRTOR_FLAG_WSS = "setPaginatedSsv2341ConfiCrtorFlagWs";
export const RESET_STATE_SSV2341_CONFI_CRTOR_FLAG_WS_FILTERS = "resetStateSsv2341ConfiCrtorFlagWsFilters";
export const RESET_STATE_SSV2341_CONFI_CRTOR_FLAG_WS = "resetStateSsv2341ConfiCrtorFlagWs";
export const RESET_STATE_SSV2341_CONFI_CRTOR_FLAG_WS_LIST = "resetStateSsv2341ConfiCrtorFlagWsList";

// SSV2303_CONFI_AUTO_FNCRA
export const SET_SSV2303_CONFI_AUTO_FNCRA = "setSsv2303ConfiAutoFncra";
export const SET_PAGINATED_SSV2303_CONFI_AUTO_FNCRAS = "setPaginatedSsv2303ConfiAutoFncra";
export const RESET_STATE_SSV2303_CONFI_AUTO_FNCRA_FILTERS = "resetStateSsv2303ConfiAutoFncraFilters";
export const RESET_STATE_SSV2303_CONFI_AUTO_FNCRA = "resetStateSsv2303ConfiAutoFncra";
export const RESET_STATE_SSV2303_CONFI_AUTO_FNCRA_LIST = "resetStateSsv2303ConfiAutoFncraList";